import React, { useEffect } from "react";

// importing MyRouts where we located all of our theme
import MyRouts from "./routers/routes";

function App() {
  useEffect(() => {
    // Ensure jQuery plugin runs after DOM is ready
    if (window.$) {
      window.$(".carousel").slick(); // example
    }
  }, []);
  return (
    <div>
      <MyRouts />
    </div>
  );
}

export default App;
